const parseIsoDate = (value) => {
  if (!value || typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  const normalised = trimmed.endsWith("Z") ? trimmed : `${trimmed}`;
  const date = new Date(normalised);
  return Number.isNaN(date.getTime()) ? null : date;
};

export function resolveSaleWindow(startIso, endIso, referenceDate = new Date()) {
  const start = parseIsoDate(startIso);
  const end = parseIsoDate(endIso);
  const now = referenceDate instanceof Date ? referenceDate : new Date();
  const nowTs = now.getTime();

  if (!start && !end) {
    return { phase: "off", start: null, end: null };
  }

  if (start && nowTs < start.getTime()) {
    return { phase: "upcoming", start, end, target: start };
  }

  if (end && nowTs > end.getTime()) {
    return { phase: "ended", start, end, target: null };
  }

  return { phase: "active", start, end, target: end || null };
}

export function formatCountdown(msRemaining) {
  if (msRemaining == null) {
    return null;
  }
  const totalSeconds = Math.max(0, Math.floor(msRemaining / 1000));
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const segments = [];
  if (days > 0) segments.push(`${days}d`);
  segments.push(`${hours.toString().padStart(2, "0")}h`);
  segments.push(`${minutes.toString().padStart(2, "0")}m`);
  segments.push(`${seconds.toString().padStart(2, "0")}s`);
  return segments.join(" ");
}
